<template>
  <div>
    <el-dialog
      :model-value="useDialogStore().anonymousRequest.visible"
      width="580px"
      top="10vh"

      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      modal-class="bg-light"

      @accept="handleAccept"
      @dismiss="handleDismiss"
    >
      <template #header>
        <div class="DialogTitle">
          <h4 class="text-primary-500">
            <icon-emergency />
            <span>Tato služba je určena lidem se sluchovým postižením.</span>
          </h4>
        </div>
      </template>

      <div class="text-base px-6">
        <p class="mb-6">
          <template v-if="useDialogStore().anonymousRequest.isFromQR">
            Níže vyberte službu online tlumočení nebo přepisu v aplikaci Tichá linka.
          </template>
          <template v-else>
            Přejete si volat prostřednictvím tlumočníka českého znakového jazyka, nebo přepisovatele českého jazyka?
          </template>
        </p>

        <iframe
          :width="isSmall ? '100%' : '560'"
          :height="isSmall ? '210' : '310'"
          class="max-w-full"
          :src="useDialogStore().anonymousRequest.isFromQR
            ? 'https://app.tichalinka.cz/youtube.html?v=aNpTEdWLVaY&autoplay=1&loop=1&mute=1&playlist=aNpTEdWLVaY'
            : 'https://app.tichalinka.cz/youtube.html?v=R7ipTuf1wd8&autoplay=1&loop=1&mute=1&playlist=R7ipTuf1wd8'"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />

        <a
          v-if="useDialogStore().anonymousRequest.visible"
          href="/"
          class="absolute lg:fixed -top-12 lg:top-6 -left-0 lg:left-[30px] block z-50"
        >
          <logo-svg
            class="text-primary-500"
          />
        </a>
      </div>

      <slot name="footer">
        <span
          class="flex items-center justify-between px-6 mt-8 flex-col-reverse sm:flex-row gap-y-5"
        >
          <el-button
            size="large"
            class="el-button--no-shadow"
            @click="handleDismiss"
          >
            Ne, zpět
          </el-button>
          <div
            v-loading="isLoading"
            class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto"
          >
            <el-button
              size="large"
              class="px-6 el-button--tertiary w-full"
              @click="() => handleAccept(2)"
            >
              Zahájit přepis
            </el-button>
            <el-button
              size="large"
              class="px-6 el-button--secondary w-full m-0"
              @click="() => handleAccept(1)"
            >
              Zahájit tlumočení
            </el-button>
          </div>
        </span>
      </slot>
    </el-dialog>
  </div>
</template>

<script setup>
import LogoSvg from '~/assets/img/logo.svg';

const emit = defineEmits(['accepted']);

// Refs
const isLoading = ref(false);

// Computed
const isSmall = useBreakpoint.smaller('sm');

// Methods
const handleAccept = async(service_id) => {
  isLoading.value = true;

  const hasAccessToEmergency = await useIpLocation().hasAccessToEmergency();
  if (!hasAccessToEmergency) {
    await sleep(2000);
    useIpLocation().accessToActionDeniedMessage();
    isLoading.value = false;

    return;
  }

  emit('accepted');

  try {
    const data = {
      service_id,
      type_id: service_id === 1 ? 1 : undefined,
      book_time: null,
      organization_uuid: useDialogStore().anonymousRequest.organizationUUID,
      is_from_qr: useDialogStore().anonymousRequest.isFromQR,
      device_id: useDeviceId().getDeviceId(),
    };

    if (!data.organization_uuid) {
      ElMessage.error({
        message: 'Omlouváme se, ale nepodařilo se najít organizaci.',
        duration: 6000,
        showClose: true,
      });
      isLoading.value = false;
      return;
    }

    const response = await useApi.post(`/client/anon-request/`, { body: data });

    useAuthStore().setAuth({
      access: response.access,
      refresh: response.refresh,
    });
    await sleep(200);
    await useAuthStore().fetchUser();
    await sleep(800);

    navigateTo(`/requests/${response.id}/waiting`);
  } catch (error) {
    console.error(error);
    const blocked = blockedMessage(error);
    let message = blocked || 'Omlouváme se, ale došlo k chybě při vytváření požadavku.';

    if (error.response?.status === 400) {
      if (service_id === 1) {
        if (useDialogStore().anonymousRequest.isFromQR) {
          message = 'Od 22:00 do 7:00 je otevřena pouze SOS linka pro urgentní případy. Přejete si volat SOS?';
          useDialogStore().open('confirmEmergency');
          closeDialog();
        } else {
          message = `Vytvořit požadavek do fronty nyní nelze, protože na toto téma tlumočník nyní nemá službu.<br>
          Pokud chcete vědět, kdy má tlumočník službu, klikněte <a href="/kalendar/${service_id === 1 ? 'tlumoceni' : 'prepis'}" target="_blank">zde</a>`;
        }
      } else if (service_id === 2) {
        message = 'Přepis je k dispozici ve všední dny 7:00-19:00. Pro svůj požadavek nyní využijte službu tlumočení, kde je přepis také možný.';
      }
    }

    ElMessage.error({
      message,
      ...blockedMessageOptions(blocked, 6000),
      dangerouslyUseHTMLString: true,
      showClose: true,
    });
  }

  isLoading.value = false;
};

const handleDismiss = () => {
  if (useRuntimeConfig().public.isIOSApp) {
    window.location.href = '/login';
  } else {
    window.history.back();

    setTimeout(() => {
      window.location.href = document.referrer || 'https://tichalinka.cz';
    }, 500);
  }
};

const closeDialog = () => {
  useDialogStore().close('anonymousRequest');
  useDialogStore().anonymousRequest.organizationUUID = null;
  useDialogStore().anonymousRequest.isFromQR = false;
};
</script>
